require('dotenv').config();
const keyCloackDbType: any = String(process.env[`APP_KEYCLOAK_DB_TYPE`]) || 'mysql';
const kafkaBrokers: string[] = [process.env[`KAFKA_BROKER`]];
export const jobConfigs = {
  port: parseInt(process.env[`APP_SERVER_PORT`]) || 3339,
  loggingMode: process.env[`APP_LOGGING_MODE`] || 'error',
  keycloak: {
    keycloakUrl: process.env[`APP_KEYCLOAK_AUTH_URL`],
    keycloakRealm: process.env[`APP_KEYCLOAK_REALM`],
    keycloakClientId: process.env[`APP_KC_CLIENT`] || 'oms-back-end',
    keycloakSecretKey: process.env[`APP_KC_SECRET`],
    keycloakDB: process.env[`APP_KEYCLOAK_DB`] || 'keycloak',
    keycloakDBType: keyCloackDbType,
    keycloakDBHost: process.env[`APP_KEYCLOAK_DB_HOST`],
    keycloakDBPort: parseInt(process.env[`APP_KEYCLOAK_DB_PORT`]),
    keycloakDBUser: process.env[`APP_KEYCLOAK_DB_USER`],
    keycloakDBPass: process.env[`APP_KEYCLOAK_DB_PASS`],
  },
  swagger: {
    basePath: process.env[`APP_SWAGGER_BASE_PATH`] || 'function/job-manager/'
  },
  responseTimeOut: parseInt(process.env[`APP_RESPONSE_TIME_OUT`]) || 600,
  arenaConfig: {
    basePath: process.env[`ARENA_BASE_PATH`] || 'function/job-manager/'
  },
  redis: {
    host: process.env[`REDIS_HOST`],
    port: parseInt(process.env[`REDIS_PORT`]) || 6379,
    password: process.env[`REDIS_PASSWORD`],
  },
  bullJobOptions: {
    //removeOnComplete: true,
    //removeOnFail: true,
    attempts: 1
  },
  bullAdvancedSettings: {
    lockDuration: 300000,
    stalledInterval: 300000,
    maxStalledCount: 1,
    guardInterval: 5000,
    retryProcessDelay: 5000,
    drainDelay: 5, // Wait time for brpoplpush in empty queue
  },
  kafka: {
    clientId: process.env.KAFKA_CLIENT_ID || 'SFCS-N',
    groupId: process.env.KAFKA_GROUP_ID || 'SFCS-PTS',
    brokers: kafkaBrokers,
  },
  concurrency: {
    MO_CREATION: parseInt(process.env[`CONCURRENCY_MO_CREATION`]) || 1,
    FG_CREATION_PTS: parseInt(process.env[`CONCURRENCY_FG_CREATION_PTS`]) || 10,
    FG_CREATION_PPS: parseInt(process.env[`CONCURRENCY_FG_CREATION_PPS`]) || 10,
    PROCESS_DOCKET_BUNDLE: parseInt(process.env[`CONCURRENCY_PROCESS_DOCKET_BUNDLE`]) || 10,
    MAP_COMP_REF_FG_COMP: parseInt(process.env[`CONCURRENCY_MAP_COMP_REF_FG_COMP`]) || 10,
    PROCESS_PRODUCT_BUNDLES_TO_FG: parseInt(process.env[`CONCURRENCY_PROCESS_PRODUCT_BUNDLES_TO_FG`]) || 20,
    EXCESS_FG_CREATION_PPS: parseInt(process.env[`CONCURRENCY_EXCESS_FG_CREATION_PPS`]) || 10,
    EXCESS_FG_CREATION_PTS: parseInt(process.env[`CONCURRENCY_EXCESS_FG_CREATION_PTS`]) || 10,
    FG_COMPONENT_CREATION_PTS: parseInt(process.env[`CONCURRENCY_FG_COMPONENT_CREATION_PTS`]) || 20,
    FG_COMPONENT_DELETION_PTS: parseInt(process.env[`CONCURRENCY_FG_COMPONENT_DELETION_PTS`]) || 5,
    MAP_FG_NUMBER_TO_DCGB: parseInt(process.env[`CONCURRENCY_MAP_FG_NUMBER_TO_DCGB`]) || 20,
  },
  m3: {
    M3_REPORTING_FLAG: process.env[`M3_REPORTING_FLAG`] == 'true' // only small case is being compared
  },

  PPS_SUB_SERVICE_URLS: {
    // dockets generation sub-service URLS
    PPS_DOCKET_GEN_JOB_URL: process.env[`PPS_DOCKET_GEN_JOB_URL`] || process.env[`PPS_DOC_GEN_HOST`],
    PPS_DOCKET_DEL_JOB_URL: process.env[`PPS_DOCKET_DEL_JOB_URL`] || process.env[`PPS_DOC_GEN_HOST`],
    PPS_PROCESS_DOCKET_BUNDLE_URL: process.env[`PPS_PROCESS_DOCKET_BUNDLE_URL`] || process.env[`PPS_DOC_GEN_HOST`],
    PPS_RECUT_DOCKET_CREATION_URL: process.env[`PPS_RECUT_DOCKET_CREATION_URL`] || process.env[`PPS_DOC_GEN_HOST`],
    PPS_REPORT_CUT_FOR_ACTUAL_DOCKET_URL: process.env[`PPS_REPORT_CUT_FOR_ACTUAL_DOCKET_URL`] || process.env[`PPS_DOC_GEN_HOST`],
    PPS_DELETE_CUTS_URL: process.env[`PPS_DELETE_CUTS_URL`] || process.env[`PPS_DOC_GEN_HOST`],

    // cuts generation sub-service URLS
    PPS_CUT_JOB_GEN_URL: process.env[`PPS_CUT_JOB_GEN_URL`] || process.env[`PPS_CUT_GEN_HOST`],
    PPS_PROCESS_CUT_JOB_URL: process.env[`PPS_PROCESS_CUT_JOB_URL`] || process.env[`PPS_CUT_GEN_HOST`],
    PPS_DELETE_CUT_JOBS_URL: process.env[`PPS_DELETE_CUT_JOBS_URL`] || process.env[`PPS_CUT_GEN_HOST`],
    PPS_PROCESS_PRODUCT_BUNDLES_TO_FG_URL: process.env[`PPS_PROCESS_PRODUCT_BUNDLES_TO_FG_URL`] || process.env[`PPS_CUT_GEN_HOST`],
    PPS_GENERATE_CUT_BASED_EMB_JOBS_URL: process.env[`PPS_GENERATE_CUT_BASED_EMB_JOBS_URL`] || process.env[`PPS_CUT_GEN_HOST`],

    // Fg Creation PPS sub-service URLS
    PPS_FG_CREATION_INVOKER_URL: process.env[`PPS_FG_CREATION_INVOKER_URL`] || process.env[`PPS_FG_GEN_HOST`],
    PPS_SAVE_FG_URL: process.env[`PPS_SAVE_FG_URL`] || process.env[`PPS_FG_GEN_HOST`],
    PPS_EXCESS_FG_CREATION_URL: process.env[`PPS_EXCESS_FG_CREATION_URL`] || process.env[`PPS_FG_GEN_HOST`],
    PPS_EXCESS_PANEL_CREATION_URL: process.env[`PPS_EXCESS_PANEL_CREATION_URL`] || process.env[`PPS_FG_GEN_HOST`],
    PPS_EXCESS_FG_PUBLISHER_URL: process.env[`PPS_EXCESS_FG_PUBLISHER_URL`] || process.env[`PPS_FG_GEN_HOST`],
    PPS_EXCESS_PANEL_DELETION_URL: process.env[`PPS_EXCESS_PANEL_DELETION_URL`] || process.env[`PPS_FG_GEN_HOST`],
    PPS_FG_DELETION_URL: process.env[`PPS_FG_DELETION_URL`] || process.env[`PPS_FG_GEN_HOST`],
    PPS_EXCESS_FG_DELETION_URL: process.env[`PPS_EXCESS_FG_DELETION_URL`] || process.env[`PPS_FG_GEN_HOST`],
  },
  PTS_SUB_SERVICE_URLS: {
    PTS_FG_CREATION_URL: process.env[`PTS_FG_CREATION_URL`] || process.env[`PTS_FG_GEN_HOST`],
    PTS_EXCESS_FG_CREATION_URL: process.env[`PTS_EXCESS_FG_CREATION_URL`] || process.env[`PTS_FG_GEN_HOST`],
    PTS_FG_DELETION_URL: process.env[`PTS_FG_DELETION_URL`] || process.env[`PTS_FG_GEN_HOST`],
    PTS_EXCESS_FG_DELETION_URL: process.env[`PTS_EXCESS_FG_DELETION_URL`] || process.env[`PTS_FG_GEN_HOST`],
    FG_COMPONENT_CREATION_PTS: process.env[`FG_COMPONENT_CREATION_PTS`] || process.env[`PTS_FG_GEN_HOST`]
  },
  M3_REPORTING_URLS: {
    M3_DATA_GEN_URL: process.env[`M3_DATA_GEN_URL`] || process.env['APP_PTS_SERVICE_URL'],
    M3_REPORT_TO_ERP_URL: process.env[`M3_REPORT_TO_ERP_URL`] || process.env['APP_PTS_SERVICE_URL'],
    M3_ELIGIBLE_FG_URL: process.env[`M3_ELIGIBLE_FG_URL`] || process.env['APP_PTS_SERVICE_URL'],
  },
  ONE_DOT_FIVE_URL: process.env[`ONEDOTFIVE`] || 'https://sfcs1.dev.brandixlk.org',
  RETRY_JOB_TIME_PERIOD: process.env[`RETRY_JOB_TIME_PERIOD`] || 10,
}

export default jobConfigs;
